/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function SelectEntityController($scope, $mdDialog,
                                               targetEntityType, selectEntityTitle, confirmSelectTitle, placeholderText,
                                               notFoundText, requiredText, onEntitySelected) {

    var vm = this;

    vm.$onInit = function () {
        vm.targetEntityType = targetEntityType;
        vm.selectEntityTitle = selectEntityTitle;
        vm.confirmSelectTitle = confirmSelectTitle;
        vm.placeholderText = placeholderText;
        vm.notFoundText = notFoundText;
        vm.requiredText = requiredText;
        vm.onEntitySelected = onEntitySelected;

        vm.selectEntity = selectEntity;
        vm.cancel = cancel;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function selectEntity() {
        $scope.theForm.$setPristine();
        if (onEntitySelected) {
            onEntitySelected(vm.targetEntityId).then(
                () => {
                    $mdDialog.hide();
                }
            );
        } else {
            $mdDialog.hide(vm.targetEntityId);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/dialog/select-entity.controller.js